import { useSelector } from 'react-redux'

import { faPlus } from '@fortawesome/pro-solid-svg-icons'

import { selectTranslate } from '../../../../reducers/LocaleReducer/LocalReducer'
import IconButton from '../../../antd/Buttons/IconButton'
import { Institution } from '../../../../utils/entities/institution'
import InstitutionsSelector from './InstitutionsSelector'
import InstitutionModal from '../../../../Providers/Forms/InstitutionModal/InstitutionModal'
import { ModalTypes } from '../../../../Providers/Forms/IndividualInternshipRequest/IndividualInternshipRequestModal'
import { selectUser } from '../../../../reducers/UserReducer'
import { getAllInstitutions } from '../../../../utils/api/institution'
import { useEffect, useState } from 'react'
import { Alert } from 'antd'
import Loading from '../../Loading'
import { isArray } from 'lodash'

const ExtendedInstitutionsSelector = ({
  className = '', disabled, dropdownDisabled, multiple = 'default', style = {}, values,
  onChange, onInstitutionSubmit, renderOption
}) => {
  const t = useSelector(selectTranslate)
  const user = useSelector(selectUser)

  const [institutionEntities, setInstitutionEntities] = useState([])
  const [moreInstitutionsCount, setMoreInstitutionsCount] = useState(0)
  const [searchValue, setSearchValue] = useState('')
  const [debounceSearch, setDebounceSearch] = useState('')
  const [loadingInstitutions, setLoadingInstitutions] = useState(false)
  const [hasInitialized, setHasInitialized] = useState(false)

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebounceSearch(searchValue)
    }, 200)

    return () => clearTimeout(timer)
  }, [searchValue])

  useEffect(() => {
    if (!hasInitialized && user) {
      setHasInitialized(true)
      return
    }

    const loadingTimer = setTimeout(() => setLoadingInstitutions(true), 200)

    getAllInstitutions(user, { page: 1, pageSize: 25, search: debounceSearch, additionalIds: isArray(values) ? values : [values] }).then(({ data, meta }) => {
      if (data) {
        if (data.length > 0) {
          setInstitutionEntities(data)
        } else {
          setInstitutionEntities(undefined)
        }
      }

      if (meta?.pages?.total) {
        const total = meta.pages.total
        setMoreInstitutionsCount(Math.max(total - 25, 0))
      } else {
        setMoreInstitutionsCount(0)
      }
    }).catch(() => {
      setInstitutionEntities(undefined)
      setMoreInstitutionsCount(0)
    }).finally(() => {
      clearTimeout(loadingTimer)
      setLoadingInstitutions(false)
    })
  }, [user, debounceSearch, hasInitialized, values])

  const renderDropdown = onClick => menu => (
    <div>
      {moreInstitutionsCount > 0 &&
        <Alert
          className='more-message'
          message={t('form.request.institutions_count_more')}
          type='info'
          showIcon
          banner
        />}
      {loadingInstitutions ? (
        <div className='p-10'>
          <Loading loading={loadingInstitutions} style={{ height: '100px' }} />
        </div>
      ) : menu}
      <div className='flex-col m-4' onMouseDown={e => e.preventDefault()}>
        <IconButton
          text={t('form.request.new_institution')}
          icon={faPlus}
          onClick={() => onClick(handler => ({ ...handler, data: new Institution(), callback: onInstitutionSubmit, type: ModalTypes.STUDENT }))}
        />
      </div>
    </div>
  )

  return (
    <InstitutionModal>
      <InstitutionsSelector
        className={className}
        disabled={disabled}
        multiple={multiple}
        institutions={institutionEntities}
        style={style}
        values={values}
        dropdownRender={!dropdownDisabled && renderDropdown}
        onChange={onChange}
        renderOption={renderOption}
        applyCustomStyles
        loading={loadingInstitutions}
        additionalDropdownMessage={moreInstitutionsCount > 0 ? t('form.request.institutions_count_more', { count: moreInstitutionsCount }) : null}
        onSearch={value => setSearchValue(value)}
        filterOption={false}
      />
    </InstitutionModal>
  )
}

export default ExtendedInstitutionsSelector
